<script setup>
import { ref, defineProps } from 'vue';
import Header from '@/components/cloudCounter/Header.vue'

defineProps({
    header: Object
});

const layoutContent = ref(null);
const goLayoutTop = (x, y) => {
    if (layoutContent.value) {
        layoutContent.value.scrollTo(x || 0, y || 0);
    }
}

</script>

<template>
    <div class="h-full flex flex-col">
        <div class="relative z-30">
            <Header :header="header"></Header>
        </div>
        <div class="flex-1 overflow-y-auto" ref="layoutContent">
            <div class="h-full flex flex-col">
                <div>
                    <slot name="top"></slot>
                </div>

                <div class="w-full max-w-3xl mx-auto px-5 pt-5 pb-10 relative flex-1">
                    <slot :method="{ goLayoutTop }"></slot>
                </div>
                <div>
                    <slot name="bottom"></slot>
                </div>
            </div>
        </div>
        <div class="fixed bottom-0 left-0 right-0 z-20">
            <slot name="fixedBottom"></slot>
        </div>
    </div>
</template>

<style scoped></style>
